import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SearchMainService } from './search.main.service';

import { prediggoTranslation } from '@assets/prediggoObject';
import { SfSiteInfo, SITE_INFO, SfLocalizeService } from '@app/sf-lib/public_api';
import { isPlatformServer } from '@angular/common';
import { FacetNotFoundService } from '@app/shared/facet-not-found/facet.not-found.service';

@Injectable({
  providedIn: 'root'
})
export class SearchFacetsResolver  {
  private readonly searchService = inject(SearchMainService);
  private readonly localize = inject(SfLocalizeService);
  private readonly facetNotFound = inject(FacetNotFoundService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly siteInfo = inject<SfSiteInfo>(SITE_INFO);

  private getKeyByValue(object, value): string {
    return Object.keys(object).find(key => object[key] === value) || '';
  }

  private translateSegments(segments: string[]): string[] {
    const x: string[] = [];
    for (let i = 0; i < segments.length / 2; i++) {
      x.push(`${segments[i * 2]}/${segments[i * 2 + 1]}`);
    }
    const y: string[] = [];
    x.forEach(val => {
      if (this.getKeyByValue(prediggoTranslation[this.localize.currentLang.code], val)) {
        y.push(this.getKeyByValue(prediggoTranslation[this.localize.currentLang.code], val));
      } else {
        if (isPlatformServer(this.platformId)) {
          this.facetNotFound.checkRedirection(this.siteInfo.path);
        }
        y.push(val);
      }
    });
    segments = y.join('/').split('/');
    return segments;
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    const url = decodeURI(state.url.split('?')[0]);
    
    let segments: string[];
    if (this.localize.currentLang.default) {
      // remove the 3 first segments
      segments = url.split('/').slice(4).filter(Boolean);
    } else {
      // Remove the 4 first segments
      segments = url.split('/').slice(5).filter(Boolean);
    }

    const filters: { [key: string]: string[] } = {};

    segments = this.translateSegments(segments).filter(Boolean);

    // fill in filters
    if (segments.length > 1) {
      for (let i = 0; i < segments.length / 2; i++) {
        if (filters[segments[i * 2]]) {
          filters[segments[i * 2]].push(segments[i * 2 + 1].replace(/%20/g, ' '));
        } else {
          filters[segments[i * 2]] = [segments[i * 2 + 1].replace(/%20/g, ' ')];
        }
      }
    }

    this.searchService.filters = filters;
    this.searchService.search();
    return filters;
  }
}
